export class AsyncAction
{
    constructor(actionName)
    {
        if (!actionName)
        {
            throw new Error('Action name must be specified');
        }
        
        this.base = actionName;
        this.pending   = `${actionName}_PENDING`;
        this.fulfilled = `${actionName}_FULFILLED`;
        this.rejected  = `${actionName}_REJECTED`;
    }
}